(ns minorodata.connections.sources.rakuten
  "Connector screen for rakuten"
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "rakuten"
   :enabled      false
   :name         "Rakuten (Deprecated)"
   :description  "The best ecommerce platform that has everything you need to sell online"
   :image-source "Rakuten_Global_Brand_Logo.svg"
   :tags         ["data-import"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [name description username password scope auth-request-token]} data]
        {:source-type "rakuten"
         :name        name
         :description description

         :source
         {:credentials         {:type                   "token"
                                :username               username
                                :password               password
                                :scope                  scope
                                :auth-request-token     auth-request-token}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge
         (select-keys credentials [:username :password :scope :auth-request-token])
         {:name              name
          :description       description})))

    :validate (constantly nil)

    :id :rakuten-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Username"
              :required   true
              :name       :username
              :value      ""}
             {:block-type :input
              :label      "Password"
              :required   true
              :name       :password
              :type       :password
              :value      ""}
             {:block-type :input
              :label      "Scope"
              :required   true
              :name       :scope
              :value      ""}
             {:block-type :input
              :label      "Token Request Authorization"
              :required   true
              :name       :auth-request-token
              :type       :password
              :placeholder "Basic ....."
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action destination-table report
                 reportid payid nid security-token bdate edate]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:report            report
                    :destination-table destination-table
                    :action            action
                    :reportid          reportid
                    :payid             payid
                    :nid               nid
                    :bdate             bdate
                    :edate             edate
                    :security-token    security-token}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:report :action :destination-table :reportid :payid :nid :security-token :bdate :edate])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status}))))

    :validate (constantly nil)

    :id :rakuten-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Events"                         :value "events"}
                           {:name "Advertiser Payments History"    :value "advanced-reports"}
                           {:name "Advanced Reports All Details"  :value "all-details"}]
              :required   true
              :value      "events"}

             {:block-type :input
              :label      "payid"
              :required   true
              :name       :payid
              :value      ""
              :conditions [[:eq [:report :value] "advanced-reports"]]}

             {:block-type :date-picker
              :label "From"
              :name :bdate
              :required false
              :conditions [[:eq [:report :value]  "all-details"]]}

             {:block-type :date-picker
              :label "To"
              :name :edate
              :required false
              :conditions [[:eq [:report :value]  "all-details"]]}

             {:block-type :select
              :label      "Network ID"
              :required   true
              :name       :nid
              :options    [{:name "UK"        :value "3"}
                           {:name "US"        :value "1"}
                           {:name "Canada"    :value "5"}
                           {:name "Australia" :value "41"}
                           {:name "France"    :value "7"}
                           {:name "Germany"   :value "9"}]
              :value      "3"
              :conditions [[:eq [:report :value] "advanced-reports"]]}

             {:block-type :input
              :label      "Security token"
              :required   true
              :name       :security-token
              :value      ""
              :type       :password
              :conditions [[:eq [:report :value] "advanced-reports"]
                           [:eq [:report :value] "all-details"]]}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
